const initialState = {
  proposals: [],
  loading: false,
  error: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PROPOSALS': {
      return { ...state, loading: true }
    }
    case 'GET_PROPOSALS_SUCCESS': {
      return {
        ...state,
        loading: false,
        error: null,
        proposals: action.payload.data
      }
    }
    case 'USER_LOGOUT': {
      return { ...initialState }
    }
    default:
      return state
  }
}

export default reducer
